<template>
  <DefaultTemplate>
    <div v-loading="loading" class="pd-x-2 pd-y-1">
      <Header
        title="ลงทะเบียนเรียนออนไลน์"
        :showSigninWith="true"
        @signIn="signIn"
      />
      <div class="flex-display js-center ai-center pd-y-3">
        <div class="border-t border-color-primary border-semi-bold width-100" />
        <div class="width-word-or">
          <h5 class="color-primary text-font-18 pd-x-4 mg-less">หรือ</h5>
        </div>
        <div class="border-t border-color-primary border-semi-bold width-100" />
      </div>
      <el-form
        label-position="top"
        :model="formSignup"
        :rules="rules"
        ref="formSignup"
        class="text-left"
      >
        <el-row :gutter="30">
          <el-col :span="24" :sm="12">
            <el-form-item label="อีเมล" prop="email" class="text-font-18">
              <el-input v-model="formSignup.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="24" :sm="12">
            <el-form-item label="รหัสผ่าน" prop="password" class="text-font-18">
              <el-input
                v-model="formSignup.password"
                :type="hidePass ? 'password' : ''"
                autocomplete="off"
              >
                <span slot="suffix">
                  <i
                    v-if="hidePass"
                    @click="hidePass = false"
                    class="cursor-pointer fas fa-eye mg-r-5"
                  ></i>
                  <i
                    v-else
                    @click="hidePass = true"
                    class="cursor-pointer fas fa-eye-slash mg-r-5"
                  ></i>
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :sm="12">
            <el-form-item
              label="ยืนยันรหัสผ่าน"
              prop="confirmPassword"
              class="text-font-18"
            >
              <el-input
                v-model="formSignup.confirmPassword"
                :type="hideConfirmPass ? 'password' : ''"
                autocomplete="off"
              >
                <span slot="suffix">
                  <i
                    v-if="hideConfirmPass"
                    @click="hideConfirmPass = false"
                    class="cursor-pointer fas fa-eye mg-r-5"
                  ></i>
                  <i
                    v-else
                    @click="hideConfirmPass = true"
                    class="cursor-pointer fas fa-eye-slash mg-r-5"
                  ></i>
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="pd-t-5">
            <span class="text-font-14 color-black">
              <el-checkbox v-model="accept"></el-checkbox> ฉันได้อ่าน และยอมรับ
              <span @click="dialogTerm = true" class="text-link"
                >เงื่อนไขการใช้บริการ</span
              >
              และ
              <span @click="dialogPrivacy = true" class="text-link"
                >นโยบายความเป็นส่วนตัว</span
              >
            </span>
          </el-col>
          <el-col :span="24" class="pd-t-3">
            <el-button
              @click="nextToStep"
              type="primary"
              class="width-100 button-auth"
              round
              >ลงทะเบียนเรียนออนไลน์</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-dialog :visible.sync="dialogTerm" class="set-width-modal">
        <h2 class="color-black mg-t-less">เงื่อนไขและข้อตกลงในการใช้บริการ</h2>
        <div class="scroll-inside">
          <p style="text-indent: 3em" class="text-justify color-black">
            เงื่อนไขการใช้บริการนี้ นำมาใช้กับผู้ใช้บริการเว็บไซต์ของ บริษัท
            เยสยูแคน จำกัด ที่ https://learning.avocadox.co
            และการบริการอื่นใดที่เราให้บริการ รวมถึงจากเว็บไซต์ของเรา
            และศูนย์บริการข้อมูล
            เราเคารพความเป็นส่วนตัวของทุกคนที่เข้าชมเว็บไซต์ของเรา
            หรือเข้ามาติดต่อเรา หรือใช้บริการของเรา
            และเรามุ่งมั่นที่จะสร้างความมั่นใจว่าทุกคนจะ
            ได้รับประสบการณ์ออนไลน์ที่มีความปลอดภัย
          </p>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogPrivacy" class="set-width-modal">
        <h2 class="color-black mg-t-less">นโยบายความเป็นส่วนตัว</h2>
        <div class="scroll-inside">
          <p style="text-indent: 3em" class="text-justify color-black">
            นโยบายความเป็นส่วนตัวนี้ นำมาใช้กับผู้ใช้บริการเว็บไซต์ของบริษัท
            เยสยูแคน จำกัด ที่ https://learning.avocadox.co
            และการบริการอื่นใดที่เราให้บริการ รวมถึงจากเว็บไซต์ของเรา
            เราเคารพความเป็นส่วนตัวของทุกคนที่เข้าชมเว็บไซต์ของเรา
            หรือใช้บริการของเรา และเรามุ่งมั่นที่จะสร้างความมั่นใจว่าทุกคนจะ
            ได้รับประสบการณ์ออนไลน์ที่มีความปลอดภัย
          </p>
        </div>
      </el-dialog>
    </div>
  </DefaultTemplate>
</template>
<style scop="scoped">
.title-list {
  text-align: left;
  margin: 0;
  margin-bottom: 10px;
  font-weight: bold;
  display: block;
}
.scroll-inside {
  max-height: 50vh;
  overflow: scroll;
}
.scroll-inside::-webkit-scrollbar {
  display: none;
}
.set-sublist {
  padding-left: 30px;
  text-align: left;
}
</style>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.formSignup.password) {
        callback(new Error("รหัสผ่านไม่ตรงกัน"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formSignup: {
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
          {
            min: 8,
            message: "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "กรุณากรอกยืนยันรหัสผ่าน",
            trigger: "blur",
          },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      dialogTerm: false,
      dialogPrivacy: false,
      accept: false,
      hidePass: true,
      hideConfirmPass: true,
      courseStatus: 0,
      courseId: "",
    };
  },
  mounted() {
    this.fetchCourse();
  },
  methods: {
    fetchCourse() {
      HTTP.get(`list/course/0/0/all`).then((res) => {
        if (res.data.success) {
          this.courseId = res.data.obj[0]._id;
        }
      });
    },
    nextToStep() {
      this.$refs["formSignup"].validate((valid) => {
        if (valid) {
          if (this.accept) {
            this.loading = true;
            let obj = {
              email: this.formSignup.email,
            };
            HTTP.post(`email`, obj)
              .then((res) => {
                if (res.data.success) {
                  this.$store.commit("SET_REGISTER", this.formSignup);
                  this.$router.push("/signup/step");
                } else {
                  this.$message.error("อีเมลของคุณถูกใช้งานแล้ว");
                }
              })
              .catch((e) => {
                this.alertCatchError(e);
                console.log("signup error", e);
              })
              .finally(() => {
                setTimeout(() => {
                  this.loading = false;
                }, 500);
              });
          } else {
            this.$message.error(
              "กรุณากดยอมรับเงื่อนไขการใช้บริการ และ นโยบายความเป็นส่วนตัว"
            );
          }
        }
      });
    },
    signIn(email, password) {
      this.loading = true;

      let obj = {
        email: email,
        password: password,
      };

      HTTP.post(`sign/in`, obj)
        .then((res) => {
          this.msgErrorValid = "";
          if (res.data.success) {
            this.$store.commit("SET_TOKEN", res.data.obj.token);
            let user = {
              email: res.data.obj.email,
              profileImg: res.data.obj.profileImg,
              role: res.data.obj.role,
              userId: res.data.obj.userId,
              titleName: res.data.obj.titleName,
              nameTH: res.data.obj.nameTH,
              surnameTH: res.data.obj.surnameTH,
              from: res.data.obj.from,
            };

            this.$store.commit("SET_USER", user);

            if (res.data.obj.role == 0) {
              this.fetchStudentsById(res.data.obj.userId);
            } else {
              setTimeout(() => {
                this.$router.push("/manage/course/list");
              }, 500);
            }
          } else {
            this.$message.error("อีเมลของคุณถูกใช้งานแล้ว");
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("signIn error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById(userId) {
      let obj = {
        _id: userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            if (res.data.obj.nameEN && res.data.obj.institution.name) {
              this.$store.commit("SET_HAVE_USER_DATA", true);
              this.$router.push("/my/course?tab=1");
            } else {
              this.$store.commit("SET_HAVE_USER_DATA", false);
              this.$router.push("/profile");
            }
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentsById error", e);
        });
    },
    fetchCourseStatus() {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj).then((res) => {
        if (res.data.success) {
          let pending = res.data.obj.pending.filter(
            (filter) => filter.courseId == this.courseId
          );

          let approved = res.data.obj.approved.filter(
            (filter) => filter.courseId == this.courseId
          );

          let disapproval = res.data.obj.disapproval.filter(
            (filter) => filter.courseId == this.courseId
          );

          if (pending.length > 0) {
            this.courseStatus = 2;
          }

          if (approved.length > 0) {
            this.courseStatus = 1;
          }

          if (disapproval.length > 0) {
            this.courseStatus = 3;
          }
        }
      });
    },
  },
};
</script>

<style scoped></style>
